export default __webpack_public_path__ + "static/media/platinum2.f1c802c4.svg";